angular.module('session')
    .factory('sessionFactory', sessionFactory);

function sessionFactory() {
    var searchFilters = {
        bookingFName: '',
        bookingLName: '',
        bookingRef: '',
        vehReg: '',
        unitName: '',
        unitReportingGroup: '',
        roomName: '',
        roomGuests: '',
        arrivalDate: '',
        departureDate: '',
        checkinStatus: '',
        sortReservations: ''
    };
    var searchForm = {
        minimisedSearchFilters: false
    };
    var savedReservations = [];
    var savedKeys = [];
    var savedProperties = [];
    var knownUserLoginFailed = '';
    var timerCount = 0;
    var savedUnitReportGroups = [];
    var lastSynced = null;
    var selectedProperty = null;
    var tempSelectedProperty = null;

    var currentLogin = {
        username: '',
        password: '',
        pin: '',
        userAttachedAccount: '',
        name: '',
        user: null,
        validated: false
    };

    var availableUsers = [];

    var session = {
        searchFilters: searchFilters,
        searchForm: searchForm,
        savedKeys: savedKeys,
        savedProperties: savedProperties,
        tempSelectedProperty: tempSelectedProperty,
        savedUnitReportGroups: savedUnitReportGroups,
        savedReservations: savedReservations,
        currentLogin: currentLogin,
        availableUsers: availableUsers,
        setBlankCurrentLogin: setBlankCurrentLogin,
        knownUserLoginFailed: knownUserLoginFailed,
        timerCount: timerCount,
        lastSynced: lastSynced,
        selectedProperty: selectedProperty,
        previousProperty: null,
        changingProperty: false,
        failedPropertyChange: false
    };
    return session;

    ///////

    function setBlankCurrentLogin() {
        return {
            username: '',
            password: '',
            pin: '',
            user: null,
            validated: false,
            sortAscending: false
        };
    }
}
